/************
 Filtering
 ************/

// Dropdowns
document.querySelectorAll(".collectionGridFilterDropdown").forEach(element => {
    // add event listener to button
    element.querySelector(".collectionGridFilterDropdownButton").addEventListener("click", function () {
        // toggle dropdown
        element.classList.toggle("open");
    });
});

// Dialog

// open
document.querySelector("#collectionFilterDialogButton").addEventListener("click", function () {
    // open dialog
    document.querySelector("#collectionFilterDialog").showModal();
});

// close
document.querySelector("#collectionFilterDialogCloseButton").addEventListener("click", function (event) {
    document.querySelector("#collectionFilterDialog").close();
});